import {
  IonBackButton,
  IonButton,
  IonButtons,
  IonCol,
  IonContent,
  IonGrid,
  IonHeader,
  IonImg,
  IonList,
  IonNote,
  IonPage,
  IonRow,
  IonSearchbar,
  IonText,
  IonTitle,
  IonToolbar,
  useIonLoading,
  useIonViewDidEnter,
} from "@ionic/react";
import { useState } from "react";
import { useRef } from "react";
import styles from "./Categories.module.scss";
import { performSearch } from "../utils";
import { SubjectListItem } from "../components/SubjectListItem";

const Search = () => {
  const searchRef = useRef();
  const [searchResults, setSearchResults] = useState([]);
  const [showLoader, hideLoader] = useIonLoading();

  useIonViewDidEnter(() => {
    searchRef.current.setFocus();
  });

  const search = async () => {
    showLoader({
      cssClass: "customLoader",
      message: "Searching...",
      duration: 9999999,
      spinner: "dots",
    });

    const searchTerm = searchRef.current.value;
    const data = await performSearch(searchTerm);

    setSearchResults(data);

    setTimeout(() => {
      hideLoader();
    }, 300);
  };

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle>Search Subjects</IonTitle>
          <IonButtons slot="start">
            <IonBackButton color="main" text="Categories" />
          </IonButtons>
        </IonToolbar>
      </IonHeader>

      <IonContent>
        <div className={styles.searchArea}>
          <IonGrid>
            <IonRow>
              <IonCol size="9">
                <IonSearchbar ref={searchRef} placeholder="Search..." />
              </IonCol>
              <IonCol size="3">
                <IonButton
                  className={styles.searchButton}
                  expand="block"
                  color="main"
                  onClick={search}
                >
                  Search
                </IonButton>
              </IonCol>
            </IonRow>
          </IonGrid>
        </div>

        {searchResults.length > 0 && (
          <IonList>
            {searchResults.map((subject, index) => {
              return (
                <SubjectListItem
                  subject={subject}
                  key={`result_${index}`}
                  fromSearch={true}
                />
              );
            })}
          </IonList>
        )}

        {searchResults.length < 1 && (
          <>
            <IonRow className="ion-justify-content-center">
              <IonCol size="12">
                <IonImg src="/assets/quizLoon.jpg" />
              </IonCol>
            </IonRow>
          </>
        )}
      </IonContent>
    </IonPage>
  );
};

export default Search;
